import {  GET_FACILITIES_REQUESTED } from './type'

export const getFacilitiesRequest = (token: string) => {
  return {
    type: GET_FACILITIES_REQUESTED,
    token
  };
};
